module.exports = __webpack_public_path__ + "static/media/post06.e0dd91f5.jpg";